module.exports = __webpack_public_path__ + "img/content5_1278_15.d00a8874.png";